import { map, when, either } from 'ramda';
import { isString, isNumber } from 'ramda-extension';

export const stringToValueLabel = (value) => ({ value, label: value });

export const transformStringOptions = map(when(either(isString, isNumber), stringToValueLabel));
